import React from 'react';

import { Sheet } from '@pkg/components';

import { NftMintSteps } from '@app/client';
import { useMintingOverlayStore } from '@app/store/zustand';

import { YatMintFlow } from './components';
import { useMintStep } from './utils';

import { SheetBackground, SheetContent } from './MintingSheet.style';

export function MintingSheet() {
    const currentStep = useMintStep();
    const { toggleShow } = useMintingOverlayStore();
    const showBackground = currentStep === NftMintSteps.YatNotVisualized;
    const showTitle = currentStep === NftMintSteps.RenameNft;
    function handleClose() {
        toggleShow();
    }

    return (
        <Sheet backdrop onClose={handleClose}>
            <Sheet.FixedCloseAction key="CloseAction" onAction={handleClose} />
            {showTitle ? <Sheet.Header onClose={handleClose} title="Rename Yat" /> : null}
            {showBackground ? <SheetBackground /> : null}
            <SheetContent>
                <YatMintFlow currentStep={currentStep} />
            </SheetContent>
        </Sheet>
    );
}
